<template>
  <div>
    <FormulateForm
      v-model="filters"
      class="form-wrapper"
      name="advancedSearchForm">
      <h6 class="text-left">Search</h6>
      <div class="flex flex-row content-center items-center gap-3">
        <input
          class="!border border-gray-100 grow outline-none text-md px-3 py-2 placeholder-gray-600 disabled:bg-gray-100"
          id="global-search-filter-input"
          v-model="searchbarKeyword"
          type="search"
          placeholder="Type to Search"
        />
        <div class="flex-row">
          <button
            class="inline-flex items-center rounded-l-lg bg-white shadow-sm h-10 p-2 hover:!bg-gray-50"
            @click="onSearch()">
            <!-- <svg
              class="ml-2 h-6"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor" >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              />
            </svg> -->
            Search
          </button>
          <button
            class="inline-flex items-center rounded-r-lg bg-white shadow-sm h-10 p-2 hover:!bg-gray-50"
            @click="onSearchClear()">
            <!-- <svg
              class="ml-2 h-6"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor" >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg> -->
            Clear
          </button>
        </div>
      </div>
    </FormulateForm>
  </div>
</template>

<script>
export default {
  props: {
    showInternalId: Boolean,
    value: String,
  },
  // model: {
  //   prop: '',
  //   event: '',
  // },
  data() {
    return {
      filters: {},
      search: this.value,
      searchbarKeyword: ''
    }
  },
  methods: {
    onSearch() {
      // emit update student event
      this.search = this.searchbarKeyword
      this.$emit('input', this.search)
      this.$emit('search')
    },
    onSearchClear() {
      this.searchbarKeyword = ''
      this.onSearch()
      this.$emit('clear')
    }
  },
  async mounted() {
    if (this.$route.query?.search !== undefined) {
      this.searchbarKeyword = this.$route.query?.search
    }
  },
  watch: {
    value(newValue) {
      console.log('SearchForm, watch:', newValue)
      this.searchbarKeyword = newValue
    }
  }
}
</script>
